import React, { FC } from 'react'
import { useVersioning, ShareWithoutVersion } from 'modules/versioning'
import { Link, useParams } from 'react-router-dom'
import { ZoomTypes, ZoomProps, Zoom } from 'components/Zoom'
import { ReactComponent as PlayIcon } from '@sketch/icons/play-20'
import ArtboardPaginationControls from '../ArtboardPaginationControls'
import { Pagination } from 'modules/shares/types'
import HeaderNavigation from '../HeaderNavigation'
import { SketchHomeButton, RouteParams } from '@sketch/modules-common'
import { ArtboardDetailInfoFragment } from '@sketch/gql-types'
import {
  NavbarBackButtonItem,
  NavbarItem,
} from '../DetailHeader/DetailHeader.styles'
import { useForTablet, Navbar } from '@sketch/components'
import BackButton from '../BackButton'

const UntypedArtboardPaginationControls = ArtboardPaginationControls as any

type EmbeddedDetailHeaderProps = {
  share: ShareWithoutVersion
  artboard: ArtboardDetailInfoFragment | undefined
  pagination?: Pagination
  showPrototypePlayButton: boolean
  onZoomChanged: ZoomProps['onZoomChanged']
  currentZoom: ZoomTypes
}

const EmbeddedDetailHeader: FC<EmbeddedDetailHeaderProps> = ({
  share,
  artboard,
  showPrototypePlayButton,
  pagination,
  currentZoom,
  onZoomChanged,
}) => {
  const { getPathname } = useVersioning()
  const { shareID, permanentArtboardShortId } = useParams<
    RouteParams<'ARTBOARD_DETAIL'>
  >()

  const isTabletAndBigger = useForTablet()
  const showPagination = pagination && isTabletAndBigger

  const prototypePath = getPathname({
    routeKey: 'PROTOTYPE',
    routeParams: { shareID, permanentArtboardShortId },
  })

  return (
    <Navbar>
      <Navbar.Section>
        <SketchHomeButton />

        <NavbarBackButtonItem>
          <BackButton />
        </NavbarBackButtonItem>

        <HeaderNavigation share={share} artboard={artboard} />
      </Navbar.Section>

      <Navbar.FixedWidthSection align="end">
        {showPrototypePlayButton && (
          <Link to={prototypePath} title="Play prototype">
            <Navbar.Button icon={PlayIcon} />
          </Link>
        )}

        {showPagination && (
          <NavbarItem>
            <UntypedArtboardPaginationControls
              current={pagination.current}
              total={pagination.total}
              showNumbers
            />
          </NavbarItem>
        )}

        <NavbarItem>
          <Zoom zoom={currentZoom} setZoom={onZoomChanged} />
        </NavbarItem>
      </Navbar.FixedWidthSection>
    </Navbar>
  )
}

export { EmbeddedDetailHeader }
